// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6150":"a344b069","7377":"da00740e"}[chunkId] + ".css";
};